import { jsxs as g, jsx as i } from "react/jsx-runtime";
import { createStyles as x, rem as f, Flex as a, Button as n } from "@mantine/core";
const u = ({ bannerSlideItems: h, onCtaButtonsClick: s, slideIndex: l }) => {
  const b = h[Number(l)], { ctaButton1: r, ctaButton2: o } = b, p = x((e) => ({
    bannerCtaButtons: {
      a: {
        fontSize: f(16),
        fontWeight: 700,
        height: f(40),
        lineHeight: f(20),
        textDecoration: "none !important"
        // Need to add !important to override the default style from Shiba
      },
      "a:first-of-type": {
        ":hover": {
          backgroundColor: (r == null ? void 0 : r.buttonColour) ?? e.colors.teal[3],
          color: `${(r == null ? void 0 : r.textColour) ?? e.colors.white ?? "#ffffff"} !important`,
          filter: `${r != null && r.buttonColour ? "brightness(110%)" : "brightness(100%)"}`
        },
        backgroundColor: (r == null ? void 0 : r.buttonColour) ?? e.colors.teal[4],
        color: (r == null ? void 0 : r.textColour) ?? e.colors.white ?? "#ffffff"
      },
      "a:nth-of-type(2)": {
        ":hover": {
          backgroundColor: (o == null ? void 0 : o.buttonColour) ?? e.colors.teal[3],
          color: `${(o == null ? void 0 : o.textColour) ?? e.colors.white ?? "#ffffff"} !important`,
          filter: `${o != null && o.buttonColour ? "brightness(110%)" : "brightness(100%)"}`
        },
        backgroundColor: (o == null ? void 0 : o.buttonColour) ?? e.colors.teal[4],
        color: (o == null ? void 0 : o.textColour) ?? e.colors.white ?? "#ffffff"
      },
      paddingBottom: "16px"
    }
  })), { classes: C } = p();
  return g(a, { className: C.bannerCtaButtons, gap: "lg", justify: "center", align: "center", direction: "row", wrap: "wrap", children: [r != null && r.text && (r != null && r.urlPath) ? i(n, { component: "a", href: r.urlPath, rel: "noopener noreferrer", size: "md", onClick: () => s(r.urlPath, 1, l), children: r.text }) : null, o != null && o.text && (o != null && o.urlPath) ? i(n, { component: "a", href: o.urlPath, rel: "noopener noreferrer", size: "md", onClick: () => s(o.urlPath, 2, l), children: o.text }) : null] });
};
export {
  u as BannerCtaButtons
};
